import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        activeNavbar: '/'
    },
    getters: {},
    mutations: {
        setActiveNavbar(state, value) {
            state.activeNavbar = value;
        }
    },
    actions: {},
    modules: {}
})
